import React from "react";
import ReactSelect from "react-select";

// noinspection JSUnusedGlobalSymbols

const Select = ({
  id,
  onChange,
  onBlur,
  value,
  isDisabled,
  options,
  businessEnquiry,
  ...props
}) => {
  const customStyles = {
    control: provided => ({
      ...provided,
      border: "0px solid transparent",
      backgroundColor: `${businessEnquiry ? "white" : "#f2f2f2"}`,
      borderRadius: "8px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#333333"
      }
    }),
    dropdownIndicator: provided => ({
      ...provided,
      color: "#333333"
    }),
    valueContainer: provided => ({
      ...provided,
      padding: "16px",
      minheight: "58px",
      height: "auto",
      "@media (max-width: 991px)": {
        minheight: "50px",
        height: "auto",
        fontSize: "1.125rem"
      }
    }),
    singleValue: provided => ({
      ...provided,
      color: "#757575",
      fontSize: "1.0625rem",
      fontWeight: "600",
      marginLeft: 0,
      "@media (min-width: 992px)": {
        fontSize: "1.125rem"
      }
    }),
    input: provided => ({
      ...provided,
      position: "relative",
      top: "-7px",
      marginLeft: 0
    }),
    placeholder: provided => ({
      ...provided,
      fontWeight: "600",
      marginLeft: 0,
      fontSize: "1.125rem"
    }),
    indicatorSeparator: () => null,
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "#f2f2f2",
      color: state.isSelected && "#cccccc",
      fontWeight: "600",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "transparent",
        color: state.isSelected ? "#cccccc" : "#fb6c3a"
      },
      "&:focus": {
        backgroundColor: "transparent",
        color: state.isSelected ? "#cccccc" : "#fb6c3a"
      },
      "&:active": {
        backgroundColor: "transparent",
        color: state.isSelected ? "#cccccc" : "#fb6c3a"
      }
    }),
    menu: provided => ({
      ...provided,
      boxShadow: "0 6px 10px 0 rgba(0, 0, 0, 0.25)",
      border: "0px solid transparent",
      borderRadius: "8px",
      overflow: "hidden",
      zIndex: 2
    })
  };
  return (
    <ReactSelect
      {...props}
      styles={customStyles}
      id={id}
      options={options}
      multi={false}
      onChange={value => onChange(id, value)}
      onBlur={() => onBlur ? onBlur(id, true) : ''}
      value={value}
      isDisabled={isDisabled}
      isSearchable={false}
    />
  );
};

export default Select;
